import React from "react";
import { Form, Input, Button, Checkbox, Layout, Row, Col } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import styled from "styled-components";
import Logo from "./fake_buzz.png"
import { connect } from "react-redux";
import { login } from "../../actions/auth";
const { Header, Footer, Content } = Layout;


const Root = styled.div`
    position: flex;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
`


 const Card = styled.div`
    position: reletive;
    box-shadow: -2px 6px 17px 2px rgba(0,0,0,0.37);
    transition: 0.3s;
    width: 40%;
    @media only screen and (max-width: 600px) {
    width: 100%;
}
  `
const LoginForm = ({login}) => {
    
  const onFinish = (values) => {
    // console.log(values);
    // history.push('/dashboard')
    login(values)
  };
  return ( 
    <Layout style={{ minHeight: "100vh", display: 'flex', justifyContent: 'center'}}>
            <Root>
                <Card>
                    <Col span={24} style={{alignSelf: 'center', borderRadius: '10px', height: '500px', backgroundColor: '#fff', padding: '20px', display: 'flex', justifyContent: 'space-around',flexDirection: 'column'}} > 
                        
                        <img src={Logo} style={{width: '100px', alignSelf: 'center'}} />
                        <h2 style={{textAlign: 'center'}}>Admin Panel</h2>
                        <Form
                        style={{alignSelf: 'center', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-around'}}
                        name="normal_login"
                        className="login-form"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        >
                        <Form.Item
                            name="email"
                            rules={[
                            {
                                required: true,
                                message: "Email is required",
                            },
                            ]}
                            style={{alignSelf: 'center',width: '100%'}}
                        >
                            <Input
                            prefix={<UserOutlined className="site-form-item-icon" />}
                            placeholder="Email"
                            size ="large"
                            />
                        </Form.Item>
                        <Form.Item
                        
                            name="password"
                            rules={[
                            {
                                required: true,
                                message: "Password is required",
                            },
                            ]}
                            style={{alignSelf: 'center',width: '100%'}}
                        >
                            <Input
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            placeholder="Password"
                            size ="large"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button
                            type="primary"
                            htmlType="submit"
                            className="login-form-button"
                            >
                            Log in
                            </Button>
                        </Form.Item>
                        </Form>
                    </Col>
                </Card>
            </Root>
        <Footer style={{ textAlign: "center", height: '10vh' }}>
          <Footer style={{ textAlign: 'center' }}>Copyright ©  2021-2022 Fakebuzz.net. All rights reserved.  </Footer>
        </Footer>
    </Layout>
  );
};

export default connect(null,{login})(LoginForm);
